// components/TrailerList/TrailerList.tsx
import React, { FC } from 'react'
import { Box, Typography, List, Divider } from '@mui/material'
import { makeStyles } from 'tss-react/mui'
import { useSelector } from 'react-redux'
import { TState } from 'redux/config/root-types'
import { ExternalLink } from 'lucide-react'
import { ITrailerFull } from 'redux/modules/trailers/TReducer'

type Props = {
  onClickTrailer: (trailer: ITrailerFull) => void
}

export const TrailerList: FC<Props> = ({ onClickTrailer }) => {
  const selectedPickUpParking = useSelector((state: TState) => state.bookings.selectedPickUpParking)
  const { classes } = useStyles({ visible: selectedPickUpParking ? true : false })

  const navigateToTrailerDetails = (id: number) => {
    const url = `/trailers/details/${id}`
    window.open(url, '_blank', 'noopener,noreferrer') // безопасно и без доступа к window.opener
  }

  return (
    <Box className={classes.root}>
      <Box className={classes.header}>
        <Typography variant="h4">Trailers</Typography>
      </Box>

      <List className={classes.list}>
        {selectedPickUpParking &&
          selectedPickUpParking.trailers &&
          selectedPickUpParking.trailers?.length > 0 &&
          selectedPickUpParking.trailers.map((trailer) => (
            <div key={trailer.id} className={classes.info} onClick={() => onClickTrailer(trailer)}>
              <div className={classes.top}>
                <div className={classes.column}>
                  <Typography variant="body1" sx={{ color: '#030712' }}>
                    {trailer.trailerType.name}
                  </Typography>
                  <Typography variant="body2" sx={{ color: '#6B7280' }}>
                    {trailer.plate}
                  </Typography>
                </div>
                <ExternalLink
                  size={'1.25rem'}
                  color="#F97316"
                  onClick={(e) => {
                    e.stopPropagation()
                    navigateToTrailerDetails(trailer.id)
                  }}
                />
              </div>
              <Divider />
              <div className={classes.subtypeInfo}>
                <div className={classes.columnCenter}>
                  <Typography variant="caption">{trailer.trailerSubtype.maxLoad}</Typography>
                  <Typography variant="caption">max load</Typography>
                </div>

                <div className={classes.columnCenter}>
                  <Typography variant="caption">{trailer.trailerSubtype.length}</Typography>
                  <Typography variant="caption">length</Typography>
                </div>
                <div className={classes.columnCenter}>
                  <Typography variant="caption">{trailer.trailerSubtype.width}</Typography>
                  <Typography variant="caption">width</Typography>
                </div>
                <div className={classes.columnCenter}>
                  <Typography variant="caption">{trailer.trailerSubtype.height}</Typography>
                  <Typography variant="caption">height</Typography>
                </div>
              </div>
            </div>
          ))}
      </List>
    </Box>
  )
}

const useStyles = makeStyles<{ visible: boolean }>()((theme, { visible }) => ({
  root: {
    position: 'absolute',
    top: 0,
    right: 0,
    width: '25rem',
    height: '100%',
    backgroundColor: theme.palette.background.paper,
    boxShadow: '-2px 0 8px rgba(0,0,0,0.15)',
    zIndex: 1000,
    display: 'flex',
    flexDirection: 'column',
    transform: visible ? 'translateX(0)' : 'translateX(100%)',
    transition: 'transform 0.5s cubic-bezier(0.25, 0.8, 0.25, 1)',
    overflow: 'hidden',
  },
  header: {
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing(1.5),
  },
  list: {
    overflowY: 'auto',
    flex: 1,
    padding: '1rem',
  },
  row: {
    display: 'flex',
    alignItems: 'center',
  },
  column: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
  },
  columnCenter: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    alignItems: 'center',
  },

  top: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: '0.75rem 1rem',
  },
  info: {
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    border: '1px solid #E5E7EB',
    marginBottom: '1rem',
    cursor: 'pointer',
  },
  subtypeInfo: {
    display: 'flex',
    alignItems: 'center',
    padding: '0.75rem 1rem',
  },
}))
